export enum HaggleProductStatus {
	Live = 'live',
	ComingSoon = 'upcoming',
	Events = 'events',
}

export enum HaggleProductEvent {
	PreOrders = 'pre-orders',
	AvailableNow = 'available-now',
}

export enum ConfigKey {
	Plans = 'plans',
}

export enum ChatStatus {
	Ongoing = 'ongoing',
	Accepted = 'accepted',
	Rejected = 'rejected',
}

export enum HaggleType {
	PUBLIC = 'PUBLIC',
	SEMI_PRIVATE = 'SEMI_PRIVATE',
	PRIVATE = 'PRIVATE',
}

export enum SubscriptionPlans {
	emerald = 'EMERALD',
	sapphire = 'SAPPHIRE',
	ruby = 'RUBY',
	diamond = 'DIAMOND',
}

export enum PriceRange {
	Under100 = 'under-100',
	OneHundredToFiveHundred = '100-500',
	FiveHundredToOneThousand = '500-1000',
	OverOneThousand = 'over-1000',
}

// Display text mappings
export const HAGGLE_STATUS_DISPLAY_TEXT = {
	[HaggleProductStatus.Live]: 'LIVE',
	[HaggleProductStatus.ComingSoon]: 'COMING SOON',
	[HaggleProductStatus.Events]: 'EVENTS',
} as const;

// Filter option constants
export const PRICE_RANGE_OPTIONS = [
	{ value: PriceRange.Under100, label: 'Under $100' },
	{ value: PriceRange.OneHundredToFiveHundred, label: '$100 - $500' },
	{ value: PriceRange.FiveHundredToOneThousand, label: '$500 - $1000' },
	{ value: PriceRange.OverOneThousand, label: 'Over $1000' },
] as const;

export const STATUS_OPTIONS = [
	{ value: HaggleProductStatus.Live, label: 'Live' },
	{ value: HaggleProductStatus.ComingSoon, label: 'Coming Soon' },
] as const;

export const EVENT_OPTIONS = [
	{ value: HaggleProductStatus.Live, label: 'Available Now' },
	{ value: HaggleProductStatus.ComingSoon, label: 'Pre-Order' },
	{ value: HaggleProductStatus.Events, label: 'Events' },
] as const;

export enum FilterPages {
	HaggleHub = 'Haggle Hub',
	ProductCollections = 'Product Collections',
}
